export default {
  Toolbar: {
    Title: {
      Phone: 'Mobile Verification Code',
      Email: 'Email Verification Code'
    }
  },

  Title: {
    Phone: 'Enter the verification code you received on your mobile',
    Email: 'Enter the verification code you received in your Email'
  },

  ExpiresIn: 'Expires in'
}
